/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsCustomEditRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsCustomEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import CustomEdit, { LazyServicedeskReportsCustomEdit } from './ui/custom-edit-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReportsCustomEditRouteEntry: Route = createEntry(
	servicedeskReportsCustomEditRoute,
	() => ({
		group: 'servicedesk',
		perfMetricKey: 'service-management.reports.custom-edit-view',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomEdit,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsCustomEdit],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
